import React, { useEffect, useState } from 'react'
import cookie from "js-cookie"
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from "sweetalert2";

function UserTable() {
    const getCookieUser = cookie.get("user");
    const userInfo = getCookieUser ? JSON.parse(getCookieUser) : null;
    console.log(userInfo, "userInfo")
    const navigate = useNavigate()
    const logoutHandler = () => {
        cookie.remove("user")
        navigate("/login")
    }
    const [count, setCount] = useState([])

    const getItemsCount = async () => {
        try {
            const result = await axios.get(
              `${process.env.REACT_APP_API_URL}/allUsers`,
              {
                headers: {
                  Authorization: `Bearer ${userInfo?.token}`,
                },
              }
            );
            console.log(result, "result")
            setCount(result.data.data)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        getItemsCount()
    }, [])

    const viewUser=(id)=>{
        navigate(`/UserView/${id}`)
    }

    const deleteHandler = (id) => {
        try {
          Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
          }).then(async (result) => {
            if (result.isConfirmed) {
              await axios.delete(
                `${process.env.REACT_APP_API_URL}/deleteUserForAdmin/${id}`,
                {
                  headers: {
                    Authorization: `Bearer ${userInfo?.token}`,
                  },
                }
              );
              getItemsCount();
              Swal.fire({
                title: "Deleted!",
                text: "Your file has been deleted.",
                icon: "success",
              });
            }
          });
        } catch (error) {
          console.log(error);
        }
      };
    return (
        <div className="d-flex">
            {/* Sidebar */}
            <div className="bg-dark text-white p-3" style={{ width: '250px', minHeight: '100vh' }}>
                <h4 className="text-center text-white mb-4">Admin Panel</h4>
                <ul className="nav flex-column">
                    <li className="nav-item mb-2">
                        <a className="nav-link text-white" href="#"><i className="fas fa-tachometer-alt me-2"></i>Dashboard</a>
                    </li>
                    <li className="nav-item mb-2">
                        <a className="nav-link text-white" href="/UserTable"><i className="fas fa-users me-2"></i>Users</a>
                    </li>
                    <li className="nav-item mb-2">
                        <a className="nav-link text-white" href="/ContactUsTable"><i className="fas fa-tools me-2"></i>Contact Us </a>
                    </li>
                    <li className="nav-item mb-2">
                        <a className="nav-link text-white" href="/BookingTable"><i className="fas fa-tools me-2"></i>Washing Services</a>
                    </li>
                    {/* <li className="nav-item mb-2">
              <a className="nav-link text-white" href="#"><i className="fas fa-shopping-cart me-2"></i>Orders</a>
            </li> */}
                    <li className="nav-item" onClick={logoutHandler}>
                        <a className="nav-link text-white" href="#"><i className="fas fa-sign-out-alt me-2"></i>Logout</a>
                    </li>
                </ul>
            </div>

            {/* Main Content */}
            <div className="p-4 flex-grow-1" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                <h2 className="mb-4">Registered Users</h2>
                <div className="table-responsive">
                    <table className="table table-bordered table-hover align-middle">
                        <thead className="table-dark">
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                {/* <th>Registered On</th> */}
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {count && count.length > 0 ? (
                                count.map((e, index) => (
                                    <tr key={index}>
                                     {   console.log(count,"count")}
                                        <td>{index + 1}</td>
                                        <td>{e?.firstname}</td>
                                        <td>{e?.email}</td>
                                        <td>{e?.phoneNumber}</td>
                                        <td>
                                            <button className="btn btn-sm btn-primary me-2" onClick={(()=>viewUser(e?._id))}>
                                                <i className="fas fa-eye"></i> View
                                            </button>
                                            <button onClick={() => deleteHandler(e?._id)} className="btn btn-sm btn-danger">
                                                <i className="fas fa-trash-alt"></i> Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">No data available</td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </div>
        </div>

    )
}

export default UserTable